import { Badge } from '@/components/ui/badge'
import { useI18n } from '@/lib/i18n'
import { Pin } from 'lucide-react'

export function ForumAdminBadge() {
  const { t } = useI18n()

  return (
    <Badge
      variant="secondary"
      className="border-sky-500/20 bg-sky-500/10 text-sky-700 hover:bg-sky-500/10 dark:text-sky-300"
    >
      {t('forum.adminBadge')}
    </Badge>
  )
}

export function ForumPinnedBadge() {
  const { t } = useI18n()

  return (
    <Badge
      variant="secondary"
      className="border-amber-500/25 bg-amber-500/10 text-amber-700 hover:bg-amber-500/10 dark:text-amber-300"
    >
      <Pin className="size-3" />
      {t('forum.pinned')}
    </Badge>
  )
}
